/**
 * Shared delivery-zone helpers: zip -> zone -> free-shipping threshold, plus the
 * cartValidZipCode storage + zipcode:* events that keep the in-cart zip field, the
 * site-wide zip popup, and the free-shipping progress bar in sync.
 *
 * Pure lookups take `zones` (defaulting to window.deliveryZones) and never touch the
 * DOM, so they're require()-able in node:test. Storage/event helpers are browser-only
 * and thin. UMD split mirrors assets/delivery-date-format.js.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.StockedDeliveryZones = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var STORAGE_KEY = 'cartValidZipCode';

  function resolveZones(zones) {
    if (Array.isArray(zones)) return zones;
    if (typeof window !== 'undefined' && Array.isArray(window.deliveryZones)) return window.deliveryZones;
    return [];
  }

  function normalizeZip(raw) {
    return String(raw == null ? '' : raw).replace(/\D/g, '').slice(0, 5);
  }

  function findZone(zip, zones) {
    var z = normalizeZip(zip);
    if (!z) return null;
    var list = resolveZones(zones);
    for (var i = 0; i < list.length; i++) {
      var zone = list[i];
      if (zone && Array.isArray(zone.zip_codes) && zone.zip_codes.indexOf(z) !== -1) return zone;
    }
    return null;
  }

  function isServiceable(zip, zones) {
    return findZone(zip, zones) != null;
  }

  function freeShippingThreshold(zip, zones) {
    var zone = findZone(zip, zones);
    if (!zone || !Array.isArray(zone.rates)) return null;
    for (var i = 0; i < zone.rates.length; i++) {
      var rate = zone.rates[i];
      if (rate && rate.price === 0 && rate.minimum_cart_value !== undefined && rate.minimum_cart_value !== null) {
        return rate.minimum_cart_value;
      }
    }
    return null;
  }

  // --- browser-only storage + events ---

  function getSavedZip() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function saveZip(zip) {
    try {
      localStorage.setItem(STORAGE_KEY, zip);
      document.dispatchEvent(new CustomEvent('zipcode:validated', { detail: { zipCode: zip } }));
    } catch (e) { /* localStorage unavailable; ignore */ }
  }

  function clearZip() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      document.dispatchEvent(new CustomEvent('zipcode:cleared'));
    } catch (e) { /* ignore */ }
  }

  return {
    STORAGE_KEY: STORAGE_KEY,
    normalizeZip: normalizeZip,
    findZone: findZone,
    isServiceable: isServiceable,
    freeShippingThreshold: freeShippingThreshold,
    getSavedZip: getSavedZip,
    saveZip: saveZip,
    clearZip: clearZip,
  };
});
